export const IsAdhesiveUsed = 'isAdhesiveUsed';
export const RemovabilityConditionId = 'removabilityConditionId';
export const AttachedToMainBody = 'attachedToMainBody';
export const RemovedBeforeUsage = 'removedBeforeUsage';
export const RemovedByConsumer = 'removedByConsumer';
